export class UpdateConveyanceSegmentRequest {
  ConveyanceID: number;
  SegmentName: String;
  Ordinal: number;
  ActionID: number;
}
